// extracted by mini-css-extract-plugin
module.exports = {"transactionActions":"SectionEditAction_transactionActions__k9Qrz"};